import React, { useEffect } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setActivePath } from "../../../redux/SidebarSlice";
import "../../css/AppSidebar.css";
import { menuConfig } from "./SideBarConstants";

const AppSibebar = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const activePath = useSelector((state) => state.activePath);

  useEffect(() => {
    dispatch(setActivePath(location.pathname));
  }, [location, dispatch]);

  const handleMenuItemClick = (path) => {
    dispatch(setActivePath(path));
  };

  return (
    <div className="sidebar-slot">
      <div className="sidebar-overlay">
        <Sidebar
          collapsed={false}
          width="200px"
          backgroundColor="#262631"
          transitionDuration={0}
          style={{ height: "100%", borderRight: "none" }}
        >
          <Menu
            menuItemStyles={{
              button: ({ active, level }) => ({
                color: active ? "#F7F7F8" : "#B6B6C2",
                backgroundColor: "transparent",
                padding: level === 0 ? "10px 12px" : "8px 16px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                borderRadius: "8px",
                fontWeight: active ? 600 : 500,
                fontSize: "0.9rem",
                minHeight: "38px",
                cursor: "pointer",
                transition: "color 0.25s ease, background-color 0.25s ease",
                "&:hover": {
                  color: "#F7F7F8",
                  backgroundColor: "rgba(255, 255, 255, 0.06)",
                },
                "& .MuiSvgIcon-root": {
                  fontSize: "1.25rem",
                  color: active ? "#F7F7F8" : "#B6B6C2",
                },
              }),
              subMenuContent: {
                backgroundColor: "#262631",
                paddingLeft: "4px",
              },
            }}
          >
            {menuConfig.map((item, index) => {
              if (item.subMenu) {
                return (
                  <SubMenu
                    key={index}
                    icon={item.icon}
                    label={item.label}
                    active={activePath.includes(item.label.toLowerCase())}
                  >
                    {item.subMenu.map((subItem, subIndex) => (
                      <MenuItem
                        key={`${index}-${subIndex}`}
                        className="sidebar-menu-item"
                        component={<Link to={subItem.path} />}
                        active={
                          activePath === subItem.path ||
                          (item.label === "Activation" &&
                            activePath.includes("/activation"))
                        }
                        onClick={() => handleMenuItemClick(subItem.path)}
                      >
                        {subItem.label}
                      </MenuItem>
                    ))}
                  </SubMenu>
                );
              }
              return (
                <MenuItem
                  key={index}
                  icon={item.icon}
                  className="sidebar-menu-item"
                  component={<Link to={item.path} />}
                  active={activePath === item.path}
                  onClick={() => handleMenuItemClick(item.path)}
                >
                  {item.label}
                </MenuItem>
              );
            })}
          </Menu>
        </Sidebar>
      </div>
    </div>
  );
};

export default AppSibebar;